import { render } from "./feature-item.vue?vue&type=template&id=3bdb3e2f&scoped=true"
import script from "./feature-item.vue?vue&type=script&lang=js"
export * from "./feature-item.vue?vue&type=script&lang=js"

import "./feature-item.vue?vue&type=style&index=0&id=3bdb3e2f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdb3e2f"]])

export default __exports__